var RecommendationStatus;
(function (RecommendationStatus) {
    RecommendationStatus["IDLE"] = "IDLE";
    RecommendationStatus["PENDING"] = "PENDING";
    RecommendationStatus["COMPLETED"] = "COMPLETED";
    RecommendationStatus["ERROR"] = "ERROR";
    RecommendationStatus["RETRIED"] = "RETRIED";
})(RecommendationStatus || (RecommendationStatus = {}));
export var RecommendationMatchStatus;
(function (RecommendationMatchStatus) {
    RecommendationMatchStatus["IDLE"] = "IDLE";
    RecommendationMatchStatus["PENDING"] = "PENDING";
    RecommendationMatchStatus["ACCEPTED"] = "ACCEPTED";
    RecommendationMatchStatus["DECLINED"] = "DECLINED";
    RecommendationMatchStatus["EXPIRED"] = "EXPIRED";
})(RecommendationMatchStatus || (RecommendationMatchStatus = {}));
export var RecommendationDateDay;
(function (RecommendationDateDay) {
    RecommendationDateDay["Mon"] = "Mon";
    RecommendationDateDay["Tue"] = "Tue";
    RecommendationDateDay["Wed"] = "Wed";
    RecommendationDateDay["Thu"] = "Thu";
    RecommendationDateDay["Fri"] = "Fri";
    RecommendationDateDay["Sat"] = "Sat";
    RecommendationDateDay["Sun"] = "Sun";
})(RecommendationDateDay || (RecommendationDateDay = {}));
export var RecommendationDatePeriod;
(function (RecommendationDatePeriod) {
    RecommendationDatePeriod["morning"] = "morning";
    RecommendationDatePeriod["afternoon"] = "afternoon";
    RecommendationDatePeriod["evening"] = "evening";
})(RecommendationDatePeriod || (RecommendationDatePeriod = {}));
export var RecommendationGrade;
(function (RecommendationGrade) {
    RecommendationGrade["any"] = "";
    RecommendationGrade["firstGrade"] = "1";
    RecommendationGrade["secondGrade"] = "2";
    RecommendationGrade["thirdGrade"] = "3";
    RecommendationGrade["fourthGrade"] = "4";
    RecommendationGrade["fifthGrade"] = "5";
    RecommendationGrade["sixthGrade"] = "6";
    RecommendationGrade["seventhGrade"] = "7";
    RecommendationGrade["eighthGrade"] = "8";
    RecommendationGrade["ninthGrade"] = "9";
    RecommendationGrade["tenthGrade"] = "10";
    RecommendationGrade["eleventhGrade"] = "11";
    RecommendationGrade["twelfthGrade"] = "12";
    RecommendationGrade["freshman"] = "freshman";
    RecommendationGrade["sophomore"] = "sophomore";
    RecommendationGrade["junior"] = "junior";
    RecommendationGrade["senior"] = "senior";
    RecommendationGrade["elementary"] = "2";
    RecommendationGrade["middle"] = "7";
    RecommendationGrade["high"] = "10";
    RecommendationGrade["college"] = "13";
})(RecommendationGrade || (RecommendationGrade = {}));
//# sourceMappingURL=recommendation.js.map